var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('div',[_c('div',{staticClass:"inline-block chevron-down mx-auto",staticStyle:{"width":"max(2.5vw, 2rem)","height":"max(2.5vw, 2rem)"}})]),_vm._v(" "),_c('div',{staticClass:"hidden-not-touch",staticStyle:{"height":"7rem"}})])
}]

export { render, staticRenderFns }